<h2 mat-dialog-title>Are you sure?</h2>
<mat-dialog-content class="mat-typography">
    <h3>{{getString()}}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Delete</button>
    <button mat-button [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>